import * as R from 'ramda'
import { Profile } from '$logic/profile/types'

export function convertProfileToAnalyticsFormat(profile: Profile) {
  if (!profile || !profile.school) return {}
  if (profile.school.role !== 'teacher') return profile.school
  // NOTE: previously we used to sent specialities as string to analytics
  // now we omit it to prevent sending with new type
  // because old users have specialities in profile.school
  // @ts-ignore
  return R.dissoc('specialities', profile.school)
}
